import { render } from "./BoletoBancario.vue?vue&type=template&id=1a8d81fa"
import script from "./BoletoBancario.vue?vue&type=script&lang=js"
export * from "./BoletoBancario.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__